import { defineStore } from 'pinia'

export const useCustomerReviewsStore = defineStore('customerReviews', {
  state() {
    return { entities: [], pages: 0 }
  },
  getters: {
    reviews: ({ entities }) => entities,
    totalPages: ({ pages }) => pages
  },
  actions: {
    async loadReviews (payload) {
      const { ApiController } = await _getModules()
      try {
        const { data, headers } = await ApiController.fetchCustomerReview(payload)
        this.entities = data
        this.pages = +headers['x-total-pages']
      } catch (e) {
        console.error('Failed to load customer reviews:', e)
      }
    }
  }
})

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const { default: ApiController } = await import('@/services/ApiController')
    cache = { ApiController }
    return cache
  }
})()
